/*
 * Single source of truth for all cookie-consent constants WITHIN the SPA. Kept
 * dependency-free (no imports from other module files) so it can be imported
 * anywhere in the module without risking circular dependencies.
 *
 * These values are also duplicated (not shared) on the JSP side and MUST be kept
 * identical there:
 *   - ghix-web/src/main/webapp/resources/js/consent/consentCookie.js
 *   - ghix-web/src/main/webapp/WEB-INF/views/cookieConsent/cookieConsentHead.jsp
 * Must-match items: GTAG command/action/value strings + dataLayer key, the cookie
 * name, max-age and max-length, and the consent cookie shape (keys + order).
 */

// Google Consent Mode v2 wire format. Changing a value here (command name,
// action, signal value, or the dataLayer property) updates every gtag push in
// cookieConsentMode.ts in one place.
export const GTAG = {
    COMMAND: 'consent',
    DATA_LAYER_KEY: 'dataLayer',
    ACTION: {
        DEFAULT: 'default',
        UPDATE: 'update',
    },
    VALUE: {
        GRANTED: 'granted',
        DENIED: 'denied',
    },
} as const;

// Local UI consent-decision states. This is the app's own state machine and is
// intentionally separate from GTAG.VALUE above, which happens to share the
// 'granted'/'denied' spellings but represents the Google wire protocol.
export const CONSENT_DECISION = {
    UNDECIDED: 'undecided',
    GRANTED: 'granted',
    DENIED: 'denied',
} as const;

// Persisted consent cookie. KEEP IN SYNC with the JSP equivalents in
// ghix-web/src/main/webapp/resources/js/consent/consentCookie.js and the inline
// snippet in shell.jsp, which duplicate these values because they run pre-GTM.
export const CONSENT_COOKIE_NAME = 'exchange_consent';
export const CONSENT_COOKIE_MAX_AGE = 60 * 24 * 60 * 60; // 60 days, in seconds
export const CONSENT_COOKIE_MAX_LENGTH = 512;
